module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-grey.b8aac79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-grey.svg
// module id = cCmC
// module chunks = 74